// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ddj2R3Bf_lgsNHPCDoVi{justify-content:space-between;align-items:center;height:40px;padding-left:12px;padding-right:12px;display:flex}.UVwc6i5JCAHtZM0ycdwA{padding-left:6px}.VyvX8TEuhcsY2UM9rhP9{margin:8px 12px;padding:2px 6px}.oLkmhAEwIuwEMrYIOS_A{color:var(--content-primary-disabled)}.oLkmhAEwIuwEMrYIOS_A.SAsRdAAYmtE429_hb4Ib{color:var(--content-negative-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ddj2R3Bf_lgsNHPCDoVi`,
	"wrapError": `UVwc6i5JCAHtZM0ycdwA`,
	"wrapTopError": `VyvX8TEuhcsY2UM9rhP9`,
	"duration": `oLkmhAEwIuwEMrYIOS_A`,
	"error": `SAsRdAAYmtE429_hb4Ib`
};
export default ___CSS_LOADER_EXPORT___;
